import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoginService } from '@delhivery/auth';
import { AUTH_CONFIG } from '@env/environment';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {
  constructor(private loginService: LoginService) {}

  ngOnInit() {
    if (!sessionStorage.getItem('access_token')) {
      const redirectUri = `${window.location.protocol}//${window.location.host}/lib-auth-oauth-callback`;
      this.loginService.login(AUTH_CONFIG.issuer, AUTH_CONFIG.clientId, redirectUri);
    }
  }
}
